import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments';
import { SubscriberService } from '../../ssr-services/subscriber/subscriber.service';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  private readonly TRANSLATE_API = environment.translateApiUrl;

  protected subscriberService = inject(SubscriberService);
  protected http = inject(HttpClient);

  public translate(message: string): Promise<string> {
    const language = this.subscriberService.subscriberLanguage().code;

    return firstValueFrom(this.translateMessage(message, language)).then(
      (result) => result ?? message
    );
  }

  private translateMessage(
    text: string,
    targetLang: string,
    sourceLang: string = 'en'
  ): Observable<string> {
    // Skip translation if source and target languages are the same
    if (sourceLang === targetLang) {
      return of(text);
    }

    const params = {
      message: text,
      targetLanguage: targetLang,
    };

    return this.http
      .get<{
        originalMessage: string;
        translatedMessage: string;
        targetLanguage: string;
      }>(this.TRANSLATE_API, { params })
      .pipe(
        map((response) => {
          const translatedText = response.translatedMessage;
          return translatedText ?? text; // Return original text if translatedText is null/undefined
        }),
        catchError(() => {
          return of(text); // Return original text if translation fails
        })
      );
  }
}
